exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link[data-v-a9cefb86] {\n  text-decoration: underline;\n}\n.textarea-box[data-v-a9cefb86] {\n  margin-left: 5px;\n}\n.green-color[data-v-a9cefb86] {\n  color: #11bb2e;\n}\n.text-delivery[data-v-a9cefb86] {\n  font-size: 14px;\n  text-decoration: underline;\n}\n", ""]);

// exports
